module.exports = __webpack_public_path__ + "img/icontype13.981e75af.png";